import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Video } from 'lucide-react';
import UnifiedBuildCampaign from '../components/buildFromEvent/UnifiedBuildCampaign';
import ZoomEmailsPanel from '../components/buildFromEvent/ZoomEmailsPanel';
import 'react-datepicker/dist/react-datepicker.css';

const Build: React.FC = () => {
  const navigate = useNavigate();
  const [zoomMode, setZoomMode] = useState(false);

  return (
    <div className="px-6 text-gray-900 dark:text-white">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
            {zoomMode ? 'Zoom Emails' : 'Build Email Campaign'}
          </h1>
          <p className="mt-2 text-sm text-gray-700 dark:text-slate-300">
            {zoomMode
              ? 'Preview the monthly Zoom announcement, test the class links, then queue Tuesday / Wednesday / Thursday to Zoom Send 1–3.'
              : 'Pick an event and up to two templates, fill shared placeholders, then schedule and queue each column.'}
          </p>
        </div>
        <div className="mt-4 sm:mt-0 sm:ml-4 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => setZoomMode((v) => !v)}
            className={`inline-flex items-center px-4 py-2 border rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
              zoomMode
                ? 'border-blue-600 text-white bg-blue-600 hover:bg-blue-700'
                : 'border-transparent text-white bg-blue-600 hover:bg-blue-700'
            }`}
          >
            <Video className="h-4 w-4 mr-2" />
            Zoom Emails
          </button>
          <button
            type="button"
            onClick={() => navigate('/templates')}
            className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-slate-600 rounded-md text-sm font-medium text-gray-700 dark:text-slate-200 bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <FileText className="h-4 w-4 mr-2" />
            Email Templates
          </button>
        </div>
      </div>

      <div className="mt-6">
        {zoomMode ? <ZoomEmailsPanel onBack={() => setZoomMode(false)} /> : <UnifiedBuildCampaign />}
      </div>
    </div>
  );
};

export default Build;
